import { Block } from "../../../types/document";
import Markdown from 'react-markdown';
import remarkGfm from "remark-gfm";
import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

interface CommentaryProps {
  block: Block;
}

export const Commentary = ({ block }: CommentaryProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!block.commentary) return null;

  return (
    <div 
      className={cn(
        "bg-zinc-100 p-4 rounded-md my-4 text-zinc-600 text-sm transition-all duration-200",
        "cursor-pointer hover:bg-zinc-200/70"
      )}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="flex items-start justify-between group/commentary">
        <div className={cn("flex-1 leading-relaxed", !isExpanded && "line-clamp-3")}>
          <Markdown remarkPlugins={[remarkGfm]}>{block.commentary}</Markdown>
        </div>
        <div className="ml-4 mt-1 text-zinc-400 group-hover/commentary:text-zinc-600 transition-colors shrink-0">
          {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
      
      {isExpanded && block.value && (
        <div className="mt-4 pt-4 border-t border-zinc-200 text-zinc-500 italic">
          <Markdown remarkPlugins={[remarkGfm]}>{block.value}</Markdown>
        </div>
      )}
    </div>
  );
};
